import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Table, Row, Col, Rate, Input } from "antd";
// import {DropOption} from '../../../components'
import styles from "./index.less";
import store from "store";

const { TextArea } = Input;
const { confirm } = Modal;
const receiveHtml = content => {};

const modalRatings = info => {
  console.log({ info });
  const {
    modalVisible,
    handleCancel,
    setReviews,
    giveRating,
    onSubmit,
    trainingId,
    trainingType,
    organisationId
  } = info;
      const user = store.get("user")
  
  const onChangeRateing = value => {
    console.log({ value });
  };
  const onChangeText = text => {
    console.log({ text });
  };
  return (
      <Modal
      visible={modalVisible}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose={false}
      width="50%"
      style={{ top: "5%" }}
      bodyStyle={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}
    >
      <div style={{ textAlign: "center", marginTop: 21 }}>
        <img
          src={require("assets/images/task_complete.png")}
          alt="Completed"
          style={{ width: 120, height: 120 }}
        />
      </div>
      <div style={{ textAlign: "center" }}>
        <div className="uk-h4 uk-text-center uk-margin-top">
          Hi {user && user.userName},<br />
          🎉 Training Complete!<br />
          {trainingType && trainingType == 4
            ? "Thanks for completing the assessment."
            : (organisationId == "63c91ba4b8354485adce4306" ||
               organisationId == "644bb77d95143a668ab5e1c8" ||
               organisationId == "652e86da5df413ad507551e1")
            ? "Congratulations and thanks for your participation in Training Assessment!!!"
            : "You've successfully finished your training."
          }
        </div>
      </div>
      <Row justify="center" style={{ width: "100%" }}>
        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
          <div style={{ display: "flex", justifyContent: "center", margin: "25px 0px 0px 0px" }}>
            <Button
              onClick={() => {
                onSubmit(trainingId);
              }}
              className="topic4"
              type="default"
              shape="round"
              style={{ border: "#30826C !important", color: "#ffffff !important" }}
            >
              Continue
            </Button>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default modalRatings;
